import React, { useState, useEffect } from 'react';
import { TiThMenu } from 'react-icons/ti';
import { useNavigate } from 'react-router-dom';
import './navbar.css';
import logo from '../images/ensenartecorto.png';

function Navbar({ onOpenFormulario }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const controlNavbar = () => {
      if (window.scrollY < 50) {
        setShowNavbar(true);
      } else if (window.scrollY > lastScrollY) {
        // Bajando
        setShowNavbar(false);
      } else {
        // Subiendo
        setShowNavbar(true);
      }

      lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', controlNavbar);

    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, []);

  const scrollToFooter = () => {
    const target = document.getElementById('footer-section');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  const items = [
    { label: 'Inicio', href: '' },
    { label: 'Tecnicos Laborales', href: '/tecnicoslaborales' },
    { label: 'Campus Virtual', href: 'https://ensenarteonline.com.co/moodle/login/index.php' },
    { label: 'Mi Plataforma', href: '/miplataforma' },
    { label: 'Gestion', href: '/administrativos' },
  ];

  return (
    <header className={`navbar ${showNavbar ? 'show' : 'hide'}`}>
      <div className="navbar-brand">
        <a
          href="#"
          className="navbar-logo-wrapper"
          aria-label="EnsenArte Inicio"
          onClick={(e) => e.preventDefault()}
        >
          <img src={logo} alt="EnsenArte" className="navbar-logo" />
        </a>
      </div>

      <nav className="navbar-links-desktop" aria-label="Navegación principal">
        {items.map((item) => (
          <button
            key={item.label}
            className="navbar-item navbar-cta"
            onClick={() => {
              if (item.label === 'Inicio') navigate('/landingpage');
              else if (item.label === 'Tecnicos Laborales') navigate('/tecnicoslaborales');
              else if (item.label === 'Mi Plataforma') navigate('/miplataforma');
              else if (item.label === 'Gestion') navigate('/administrativos');
              else if (item.label === 'ICFES') navigate('/administrativos/icfes');
              else window.open(item.href, '_blank');
            }}
          >
            {item.label}
          </button>
        ))}
        <button className="navbar-item navbar-cta" onClick={() => navigate('/interes')}>
          Más info
        </button>
        <button className="navbar-item navbar-cta" onClick={scrollToFooter}>
          Redes sociales
        </button>
      </nav>

      <button
        className="navbar-toggle"
        onClick={() => setMenuOpen((cur) => !cur)}
        aria-expanded={menuOpen}
        aria-label="Mostrar menú"
      >
        <TiThMenu size={28} color="white" />
      </button>

      <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
        <div className="navbar-menu-header">
          <a
            href="#"
            className="navbar-logo-wrapper"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
            }}
          >
            <img src={logo} alt="EnsenArte" className="navbar-menu-logo" />
          </a>
        </div>

        <nav className="navbar-links">
          {items.map((item) => (
            <button
              key={item.label}
              className="navbar-item navbar-cta"
              onClick={() => {
                setMenuOpen(false);

                if (item.label === 'Inicio') navigate('/landingpage');
                else if (item.label === 'Tecnicos Laborales') navigate('/tecnicoslaborales');
                else if (item.label === 'Mi Plataforma') navigate('/miplataforma');
                else if (item.label === 'Gestion') navigate('/administrativos');
                else if (item.label === 'ICFES') navigate('/administrativos/icfes');
                else window.open(item.href, '_blank');
              }}
            >
              {item.label}
            </button>
          ))}

          <button
            className="navbar-item navbar-cta"
            onClick={() => {
              setMenuOpen(false);
              navigate('/interes');
            }}
          >
            Más info
          </button>

          <button className="navbar-item navbar-cta" onClick={scrollToFooter}>
            Redes sociales
          </button>
        </nav>
      </div>

      <div
        className={`navbar-overlay ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />
    </header>
  );
}

export default Navbar;